(function() {
  var InviteTab,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  InviteTab = App.loadClass("grower::handlers/contacts/tabs/Invite_Tab_Handler");

  exports.Edit_Permission_Dialog = (function(superClass) {
    extend(Edit_Permission_Dialog, superClass);

    function Edit_Permission_Dialog() {
      return Edit_Permission_Dialog.__super__.constructor.apply(this, arguments);
    }

    Edit_Permission_Dialog.prototype.afterSave = function(json) {
      var i, k, o, options, ref, ref1, sel, ths, v, writer;
      ths = this;
      writer = ths.dialog.find('.message_writer');
      o = json.status.msg;
      if (json.status.type !== "success") {
        o += '<ul>';
        ref = json.data.messages;
        for (k in ref) {
          v = ref[k];
          o += "<li>" + v + "</li>";
        }
        o += "</ul>";
      }
      writer.message_writer(json.status.type, o);
      if (json.status.type === "success") {
        sel = ths.dialog.find('.sel-edit-permission');
        if (json.data.new_title) {
          options = sel.children('option').each(function() {
            if ($(this).val() === json.data.permission_id) {
              return $(this).html(json.data.new_title);
            }
          });
          ref1 = App.current_page.activeSubHandlers;
          for (i in ref1) {
            v = ref1[i];
            if (v instanceof InviteTab) {
              $(v.layoutSelector).find('.btn-search').click();
            } else {
              App.current_page.refreshSubHandlers();
            }
          }
        }
        ths.dialog.find('.sel-edit-permission').val('');
        writer.message_writer('hide');
        ths.dialog.find('form').slideUp();
        return setTimeout((function(_this) {
          return function() {
            return ths.destroy();
          };
        })(this), 2000);
      } else {
        return ths.errorAction(json);
      }
    };

    Edit_Permission_Dialog.prototype.init = function() {
      var ths;
      ths = this;
      this.layoutUrl = 'backend/grower/contacts/editpermissionform';
      this.classes = 'large_dialog';
      this.saveUrl = 'backend/grower/contacts/editpermission-ajax';
      this.refreshNavHandler = false;
      return this.createDialog();
    };

    Edit_Permission_Dialog.prototype.afterLoadLayout = function() {
      var self;
      self = this;
      this.openDialog();
      this.dialog.find('.sel-edit-permission').change(function() {
        var id;
        id = $(this).val();
        if (id === '') {
          self.dialog.find('#frm_editpermission').hide();
          self.dialog.find('.save-btn').hide();
          return self.setPosition();
        } else {
          self.getPermission(id, function() {
            return self.setPosition();
          });
          return self.dialog.find('.save-btn').show();
        }
      });
      this.dialog.find('.save-btn').hide();
      return this.submitAction = (function(_this) {
        return function() {
          var valid;
          valid = _this.dialog.find("#frm_editpermission").validationEngine('validate');
          if (valid) {
            return _this.save("Saving...");
          }
        };
      })(this);
    };

    Edit_Permission_Dialog.prototype.getPermission = function(id, callback) {
      if (callback == null) {
        callback = null;
      }
      this.dialog.find('.message_writer').message_writer('info', 'Loading...');
      return $.post('backend/grower/contacts/get-permissionform-ajax', {
        id: id
      }, (function(_this) {
        return function(response) {
          var cdata, render;
          cdata = response.data;
          _this.dialog.find('.permission-title').val(cdata.title);
          _this.dialog.find('.permission-id').val(cdata.id);
          render = _this.dialog.find(".permissions-template").render(cdata);
          _this.dialog.find('.permissions-table-wrapper').html(render);
          _this.dialog.find('#frm_editpermission').show();
          _this.dialog.find('#frm_editpermission').validationEngine({
            promptPosition: "centerRight",
            ajaxFormValidationMethod: "POST"
          });
          _this.dialog.find('.message_writer').message_writer('success', 'Loaded');
          _this.dialog.find('.message_writer').message_writer('hide');
          _this.dialog.find('.multi-control').click(function(e) {
            var affect, affectClass, checkboxes, table, unchecked;
            if ($(this).is('.view')) {
              affectClass = '.con_addView';
            } else if ($(this).is('.add')) {
              affectClass = '.con_addAdd';
            }
            affect = affectClass + " :checkbox";
            table = $(this).parents('table');
            checkboxes = $(table).find(affect);
            unchecked = false;
            checkboxes.each(function() {
              if (!$(this).prop('checked')) {
                unchecked = true;
                return $(this).prop('checked', true);
              } else {

              }
            });
            if (!unchecked) {
              return checkboxes.each(function() {
                return $(this).prop('checked', false);
              });
            }
          });
          return _this.afterPermissionLoaded();
        };
      })(this));
    };

    Edit_Permission_Dialog.prototype.afterPermissionLoaded = function() {
      return this.setPosition();
    };

    return Edit_Permission_Dialog;

  })(DialogHandler);

}).call(this);
